import React, { useState } from 'react';
import './team.css';
import { createTeams, getTeamsByUserId } from '../../Services/APIrequests'; 
import { fetchTeams } from './Myaccount';

const CreateTeamModal = ({ onCreate, onClose,setteams,setActiveTab }) => {
  const [teamName, setTeamName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (teamName.trim()) {
      setLoading(true);
      setErrorMessage(''); 
      try {
        const response = await createTeams({ teamName });
        const responseData = response.data;
  
        if (responseData && responseData.success) {
          // onCreate(teamName); 
          setActiveTab(responseData?.teamId)
          setteams(prev=>[...prev,{teamId:responseData?.teamId,teamName:teamName}])
          onClose(); 


        } else {
          setErrorMessage(responseData?.message || 'Failed to create team. Please try again.');
        }
      } catch (error) {
        const errorMsg = error.response?.data?.message || error.message || 'An unexpected error occurred.';
        setErrorMessage(errorMsg);
        console.error('Exception during team creation:', errorMsg); 
      } finally {
        setLoading(false); 
      }
    } else {
      setErrorMessage('Please enter a valid team name.');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Create a New Team</h2>
        <input
          type="text"
          placeholder="Enter team name"
          value={teamName}
          onChange={(e) => setTeamName(e.target.value)}
          className="team-name-input"
        />
        {errorMessage && <p className="error-message">{errorMessage}</p>} 
        <div className="modal-buttons">
          <button onClick={handleSubmit} className="create-button" disabled={loading}>
            {loading ? 'Creating...' : 'Create'} 
          </button>
          <button onClick={onClose} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateTeamModal;
